import React from 'react';
import { CoachIcon } from '../svg/CoachIcon';
import { GamerIcon } from '../svg/GamerIcon';
import { CoachDollar } from '../svg/scholarships/CoachDollar';
import { CoachScholar } from '../svg/scholarships/CoachScholar';
import { Controller } from '../svg/scholarships/Controller';
import { OpporCard } from './card/OpporCard';

type Props = {
    className?: string;
};

export const Opportunities: React.FC<Props> = ({ className }) => {
    return (
        <div className="scholar-opportunities">
            <div className="container slim">
                <div className="scholar-content">
                    <h2 className="scholar-tagline">{'COLLEGE ESPORTS OPPORTUNITIES AT YOUR FINGERTIPS'}</h2>
                    <div className="scholar-grid">
                        <OpporCard
                            icon={<Controller className="controller-icon" />}
                            description={'Play for'}
                            tagline={'Scholar Dollars'}
                        />
                        <OpporCard
                            icon={<CoachDollar className="coach-dollar" />}
                            description={'Additional'}
                            tagline={'Opportunities'}
                        />
                        <OpporCard
                            icon={<CoachScholar className="coach-scholar" />}
                            description={'Talk with'}
                            tagline={'Recruiting experts'}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
